(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name itecAdministracio.api.entitat.factory:EntitatFactory
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.tyk')
    .factory('TykFactory', TykFactory);
  function TykFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'tyks';

    var TykBase = {

      getTyksEntitat: function(identitat){
        var url = api;
        return DataFactory.getWithParams(url, {"identitat":identitat});
      }
    };
    return TykBase;
  }
}());
